import React, { useEffect } from "react";
import FormWarning from "./FormWarning";
import MultilineCustomInput from "../../../common/components/CustomInput/MultilineCustomInput.jsx";

const MultilineOpenInput = props => {
  const { propName } = props;
  const setPropMounted = props.connectForm.setPropMounted;

  useEffect(() => {
    setPropMounted(propName, true);
    return () => {
      setPropMounted(propName, false);
    };
  }, [setPropMounted, propName]);

  const spreadIt = props.inputProps == null ? {} : props.inputProps;
  return (
    <div>
      <MultilineCustomInput
        success={props.connectForm.getState(propName) === "Success"}
        error={props.connectForm.getState(propName) === "Error"}
        labelText={
          <span>
            {props.connectForm.getLabel(propName) + " "}
            {props.connectForm.isRequired(propName) ? <span>*</span> : ""}
          </span>
        }
        id={propName}
        formControlProps={{
          fullWidth: true
        }}
        inputProps={{
          onChange: event =>
            props.connectForm.change(event.target.value, propName),
          value: props.connectForm.getValue(propName),
          autoComplete: "off",
          ...spreadIt
        }}
      />
      <FormWarning
        isValid={props.propName}
        isError={props.connectForm.getState(propName)}
        errorMessage={props.connectForm.getErrorMessage(propName)}
      />
    </div>
  );
};

export default MultilineOpenInput;
